import Vue from 'vue'
import i18n from 'i18n'
import { toFixed } from 'utils/common'

// 大数字处理
Vue.filter('largeNumber', (value, digits = 2) => {
  if (!value || isNaN(value)) return 0
  if (Math.abs(value) >= 10000 * 10000 * 10000) {
    // 英文下为T，中文为万亿
    return `${toFixed(value / (10000 * 10000 * 10000), digits)}${i18n.t(
      'unit-10000M'
    )}`
  }
  const local = i18n.locale || 'en-us'
  if (local === 'en-us') {
    // 英文下单位为K（千）/ M（百万）/ B（十亿）/ T(万亿)
    if (Math.abs(value) >= 10 * 10000 * 10000) {
      return `${toFixed(value / (10 * 10000 * 10000), digits)}` + 'B'
    }
    if (Math.abs(value) >= 100 * 10000) {
      return `${toFixed(value / (100 * 10000), digits)}` + 'M'
    }
    if (Math.abs(value) >= 1000) {
      return (value / 1000).toFixed(digits) + 'K'
    }
  } else {
    // 中文下单位为万 / 亿 / 万亿
    if (Math.abs(value) >= 10000 * 10000) {
      return `${toFixed(value / (10000 * 10000), digits)}${i18n.t('unit-100M')}`
    }
    if (Math.abs(value) >= 10000) {
      return `${toFixed(value / 10000, digits)}${i18n.t('unit-10K')}`
    }
  }
  if (Number.isInteger(+value)) {
    digits = 0
  }
  return parseFloat(value).toFixed(digits)
})
